<template>
  <div>
    <q-page padding>
      <div
        class="row col-12 text-brand-5"
        style="cursor: pointer"
        @click="voltar()"
      >
        <q-icon
          style="margin-top: 3px"
          size="sm"
          name="arrow_back_ios"
          class="cursor"
        />
        <p class="text-h6 text-brand-5 text-weight-bold texto-titulo">
          Detalhe da Sala de Treinamento
        </p>
      </div>
      <div
        class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
      >
        <div class="col-md-2 col-sm-6 col-xs-6">
          <div class="q-ml-sm texto-titulo-input">Treinamento</div>
          <q-input
            disable
            bg-color="brand-7"
            v-model="dados.treinamento"
            dense
            outlined
            class="input"
          />
        </div>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <div class="q-ml-sm texto-titulo-input">Agendado Para</div>
          <q-input
            disable
            bg-color="brand-7"
            v-model="dados.agendadoPara"
            dense
            outlined
            class="input"
          />
        </div>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <div class="q-ml-sm texto-titulo-input">Local</div>
          <q-input
            disable
            bg-color="brand-7"
            v-model="dados.local"
            dense
            outlined
            class="input"
          />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6">
          <div class="q-ml-sm texto-titulo-input">Instrutor</div>
          <q-input
            disable
            bg-color="brand-7"
            v-model="dados.instrutor"
            dense
            outlined
            class="input"
          />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6">
          <div class="q-ml-sm texto-titulo-input">Sala Criada</div>
          <q-input
            disable
            bg-color="brand-7"
            v-model="dados.salaCriada"
            dense
            outlined
            class="input"
          />
        </div>
      </div>
      <div class="row col-12 q-ml-md q-mt-lg">
        <p></p>
        <q-btn
          class="q-mt-sm"
          label="Criar Capacitação"
          no-caps
          color="primary"
          :disable="dadosAgendamento.length == 0"
          icon="add"
          :outline="!rightDrawerOpen"
          @click="(rightDrawerOpen = true), receberDadosCriarCapacitacao()"
        />
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerOpen" class="drawer-modal">
          <div class="q-pa-md text-weight-bold" style="height: 92%">
            <div class="row col-12 justify-between items-center">
              <div v-if="!adicionarPessoas" class="col-md-12 items-center">
                <q-icon
                  style="cursor: pointer; margin-bottom: 1px"
                  name="close"
                  class="q-mr-xs"
                  size="19px"
                  @click="rightDrawerOpen = false"
                />
                <span style="font-size: 16px">
                  <span> Criar Capacitação </span>
                </span>
              </div>
              <div v-else class="col-md-12 items-center">
                <q-icon
                  style="cursor: pointer; margin-bottom: 1px"
                  name="arrow_back_ios"
                  class="q-mr-xs"
                  size="19px"
                  @click="adicionarPessoas = false"
                />
                <span style="font-size: 16px">
                  <span> Adicionar Pessoas </span>
                </span>
              </div>
            </div>
            <div
              v-if="!adicionarPessoas"
              class="column justify-between"
              style="height: 100%; width: 100%"
            >
              <div>
                <div class="col-md-12 q-mt-md">
                  <div class="q-mb-xs">Descrição</div>
                  <q-input
                    dense
                    outlined
                    v-model="dadosCriarCapacitacao.dados.treinamentoNome"
                  />
                </div>
                <div class="col-md-12 q-mt-sm">
                  <div class="q-mb-xs">Instrutor</div>
                  <q-input
                    dense
                    outlined
                    v-model="dadosCriarCapacitacao.dados.instrutor"
                    disable
                  />
                </div>
                <div class="row col-12 q-mt-sm">
                  <div class="col-12 q-mr-sm">
                    <div class="texto-titulo-input q-mb-xs">Data Aplicação</div>
                    <q-input
                      v-model="dados.dataAplicacao"
                      dense
                      outlined
                      class="input"
                      placeholder="DD/MM/AAAA"
                      mask="##/##/####"
                    >
                      <template v-slot:append>
                        <q-icon name="event" class="cursor-pointer">
                          <q-popup-proxy
                            cover
                            transition-show="scale"
                            transition-hide="scale"
                          >
                            <q-date
                              v-model="dados.dataAplicacao"
                              :locale="myLocale"
                              mask="DD/MM/YYYY"
                            >
                              <div class="row items-center justify-end">
                                <q-btn
                                  v-close-popup
                                  label="Fechar"
                                  color="primary"
                                  flat
                                />
                              </div>
                            </q-date>
                          </q-popup-proxy>
                        </q-icon>
                      </template>
                    </q-input>
                  </div>
                </div>
                <div class="col-md-12 q-mt-sm">
                  <div class="q-mb-xs">Instrutor ID</div>
                  <q-input
                    dense
                    outlined
                    v-model="dadosCriarCapacitacao.instrutorId"
                  />
                </div>
                <div class="col-md-12 q-mt-sm">
                  <div class="q-mb-xs">Reciclagem</div>
                  <q-radio
                    label="Sim"
                    :val="true"
                    v-model="dadosCriarCapacitacao.reciclagem"
                  />
                  <q-radio
                    label="Não"
                    :val="false"
                    v-model="dadosCriarCapacitacao.reciclagem"
                  />
                </div>
                <div class="q-mt-md">
                  <p></p>
                  <q-btn
                    label="Adicionar Pessoas"
                    no-caps
                    color="primary"
                    dense
                    icon="add"
                    @click="adicionarPessoas = true"
                  />
                </div>
                <div class="q-mt-md">
                  {{ selected?.length }}
                  {{
                    selected?.length > 1
                      ? "pessoas selecionadas"
                      : "pessoa selecionada"
                  }}
                </div>
              </div>
              <div class="row">
                <div class="row col-12 justify-end">
                  <q-btn
                    icon="add_circle_outline"
                    color="positive"
                    label="Criar"
                    dense
                    no-caps
                    @click="criarCapacitacaoPorAgendamento()"
                  />
                </div>
              </div>
            </div>
            <div
              v-else
              class="column justify-between"
              style="height: 100%; width: 100%"
            >
              <div class="q-mt-md col-12">
                <span
                  >{{ selected?.length }}
                  {{
                    selected?.length > 1
                      ? "pessoas selecionadas"
                      : "pessoa selecionada"
                  }}</span
                >
                <div
                  class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
                >
                  <q-input
                    rounded
                    outlined
                    dense
                    debounce="300"
                    type="text"
                    class="col-md-5 col-xs-12"
                    placeholder="Pesquisar"
                    v-model="buscarParticipante"
                  >
                    <template v-slot:append>
                      <q-icon name="search" />
                    </template>
                  </q-input>
                </div>
                <q-table
                  :columns="columns2"
                  :rows="listaUsuarios"
                  color="primary"
                  table-header-class="bg-accent text-weight-bold"
                  flat
                  hide-bottom
                  dense
                  class="tabela-tamanho-fixo"
                  row-key="name"
                  selection="multiple"
                  :loading="loading"
                  v-model:selected="selected"
                  v-model:pagination="pagination"
                  :rows-per-page-options="[0]"
                >
                  <template v-slot:header="props">
                    <q-tr :props="props">
                      <q-th
                        class="text-weight-bolder"
                        v-for="col in props.cols"
                        :key="col.name"
                        :props="props"
                      >
                        {{ col.label }}
                      </q-th>
                    </q-tr>
                  </template>
                  <template v-slot:body="props">
                    <q-tr class="text-brand-5 text-weight-bold">
                      <q-td>
                        <q-checkbox
                          :val="props.row.id"
                          v-model="selected"
                          icon="add_circle"
                          color="blue-8"
                          style="margin-left: 4px"
                          :disable="verificarUsuario(props.row?.id)"
                        />
                      </q-td>
                      <q-td>
                        <span> {{ props.row?.name }}</span>
                      </q-td>
                      <q-td>
                        <span> {{ props.row?.sap }}</span>
                      </q-td>
                    </q-tr>
                  </template>
                </q-table>
                <div class="row justify-end q-mt-md">
                  <q-pagination
                    :disable="disable"
                    v-model="pagination.page"
                    color="brand-5"
                    active-color="secondary"
                    active-text-color="white"
                    :max="pagesNumber"
                    :max-pages="5"
                    :boundary-numbers="false"
                    :direction-links="true"
                    size="sm"
                  />
                </div>
              </div>
            </div>
          </div>
        </q-card>
      </Transition>
      <div class="q-mt-xl">
        <div class="row col-12 q-my-lg justify-between items-center">
          <span
            class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
          >
            Pessoas Inscritas no Treinamento
          </span>
        </div>
        <q-table
          :columns="columns"
          :rows="listaUsuariosAgendamento"
          color="primary"
          table-header-class="bg-accent text-weight-bold"
          flat
          hide-bottom
          class="tabela-tamanho-fixo"
          dense
          :grid="$q.screen.lt.sm"
          :rows-per-page-options="[0]"
        >
          <template v-slot:item="props">
            <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
              <div class="row card text-grid-table text-brand-5 q-pa-sm">
                <div
                  class="row col-12 justify-center items-center justify-between"
                >
                  <div class="col-8">
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span class="q-mr-sm"
                        ><strong class="q-mr-xs"
                          >Nome: {{ props.row.usuarioNome }}
                        </strong>
                      </span>
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span class="q-mr-sm"
                        ><strong class="q-mr-xs"
                          >Matricula: {{ props.row.usuarioMatricula }}
                        </strong>
                      </span>
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span class="q-mr-sm"
                        ><strong class="q-mr-xs"
                          >Data de Confirmação:
                          {{
                            props.row.updatedAt
                              ?.split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("/")
                          }}
                          {{ props.row.updatedAt.split(" ")[1] }}
                        </strong>
                      </span>
                    </div>
                    <div class="row col-12 q-ml-sm q-mt-sm">
                      <span class="q-mr-sm"
                        ><strong class="q-mr-xs"
                          >Email: {{ props.row.usuarioEmail }}
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:body-cell-nome="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              {{ props.row.usuarioNome }}
            </q-td>
          </template>
          <template v-slot:body-cell-matricula="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              {{ props.row.usuarioMatricula }}
            </q-td>
          </template>
          <template v-slot:body-cell-dataConfirmacao="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              <span>
                {{
                  props.row.data_inscricao
                    ?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </span>
              <span class="row q-ml-sm">
                {{ props.row.data_inscricao?.split(" ")[1] }}</span
              >
            </q-td>
          </template>
          <template v-slot:body-cell-email="props">
            <q-td class="text-brand-5 text-weight-bold" :props="props">
              {{ props.row.usuarioEmail }}
            </q-td>
          </template>
        </q-table>
      </div>
    </q-page>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "matricula",
    label: "Matricula",
    align: "left",
  },
  {
    name: "dataConfirmacao",
    label: "Data de Confirmação",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
  },
];
const columns2 = [
  {
    name: "selecionar",
    label: "Selecionar",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "sap",
    label: "Id",
    align: "left",
  },
];
export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();

    const agendamentoUuid = route.params.agendamentoUuid;
    const dados = ref({
      treinamento: "",
      agendadoPara: "",
      local: "",
      instrutor: "",
      salaCriada: "",
    });
    const listaUsuariosAgendamento = ref([]);
    let rightDrawerOpen = ref(false);
    const dadosCriarCapacitacao = ref({
      dados: {},
      dadosFuncionarios: [],
      instrutorId: "",
      reciclagem: false,
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 10,
    });
    let adicionarPessoas = ref(false);
    const selected = ref([]);
    const listaUsuarios = ref([]);
    let loading = ref(false);
    let disable = ref(false);
    const listaUsuariosSelecionadosAgendamento = ref([]);
    const buscarParticipante = ref("");
    const dadosAgendamento = ref([]);

    const detalharAgendamento = async () => {
      try {
        const response = await store.dispatch(
          "treinamento/detalharAgendamento",
          {
            data_final: "31/12/2040",
            uuid_agendamento: agendamentoUuid,
          }
        );
        dadosAgendamento.value = response.data.data;
        if (response.data.data[0].data_inscricao) {
          listaUsuariosAgendamento.value = response.data.data;
        }
        if (response.data.data[0]) {
          let array = response.data.data[0];
          dados.value = {
            treinamento: array.treinamentoNome,
            agendadoPara: `${array.momentoRealizacao
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("/")} ${array.momentoRealizacao.split(" ")[1]}`,
            local: array.local,
            instrutor: array.instrutor,
            salaCriada: `${array.createdAt
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("/")} ${array.createdAt.split(" ")[1]}`,
            dataAplicacao: new Date().toLocaleString("pt-br").split(" ")[0],
          };
          return;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const voltar = () => {
      router.push({ name: "treinamento-agendamento" });
    };

    const receberDadosCriarCapacitacao = () => {
      selected.value = [];
      dadosCriarCapacitacao.value.dados = {
        ...dadosAgendamento.value[0],
      };
      if (dadosAgendamento.value[0].usuarioId == null) {
        return;
      }
      listaUsuariosAgendamento.value.forEach((usuario) => {
        selected.value.push(usuario.usuarioId);
      });
      listaUsuariosSelecionadosAgendamento.value = [...selected.value];
    };

    const listarUsuarios = async (page = 1, rowsNumber = 6) => {
      await store.state.org.unidadeData.id;
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch("treinamento/listarUsuarios", {
          vendor_id: store.state.org.unidadeData.id,
          per_page: rowsNumber,
          page: page,
          search: buscarParticipante.value,
        });
        listaUsuarios.value = response.data.results.data;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsNumber = response.data.results.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const resetVariaveis = () => {
      dadosCriarCapacitacao.value = {
        dados: {},
        dadosFuncionarios: [],
        instrutorId: "",
        reciclagem: false,
      };
      selected.value = [];
      adicionarPessoas.value = false;
    };

    const verificarUsuario = (id) => {
      return listaUsuariosSelecionadosAgendamento.value.some(
        (usuario) => usuario == id
      );
    };

    const criarCapacitacaoPorAgendamento = async () => {
      if (dadosCriarCapacitacao.value.dados.treinamentoNome == "") {
        quasar.notify({
          message: "Preencha o campo descrição.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dados.value.dataAplicacao === "") {
        quasar.notify({
          message: "Preencha o campo data aplicação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dadosCriarCapacitacao.value.instrutorId == "") {
        quasar.notify({
          message: "Preencha o campo instrutor Id.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (selected.value.length == 0) {
        quasar.notify({
          message: "Adicione ao menos uma pessoa",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch(
          "treinamento/criarCapacitacaoPorAgendamento",
          {
            unidadeId: store.state.org.unidadeData.id,
            agendamentoId: agendamentoUuid,
            instrutorId: dadosCriarCapacitacao.value.instrutorId,
            instrutorNome: dadosCriarCapacitacao.value.dados.instrutor,
            descricao: dadosCriarCapacitacao.value.dados.treinamentoNome,
            funcionarios: selected.value,
            reciclagem: dadosCriarCapacitacao.value.reciclagem,
          }
        );
        quasar.notify({
          message: "Capacitação criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        finalizarCapacitacao(response.data.data.id);
      } catch (error) {
        quasar.notify({
          message: "Erro ao criar capacitação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const finalizarCapacitacao = async (capacitacaoId) => {
      try {
        const response = await store.dispatch(
          "treinamento/finalizarCapacitacao",
          {
            capacitacaoId: capacitacaoId,
            dataRealizacao: dados.value.agendadoPara.split(" ")[0],
          }
        );
        let id = response.data.data.id;
        router.push({
          name: "treinamento-detalhe-capacitacao",
          params: { capacitacaoId: id },
        });
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        listarUsuarios(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value == false) {
          resetVariaveis();
        }
      }
    );

    watch(
      () => buscarParticipante.value,
      () => {
        listarUsuarios();
      }
    );

    onMounted(() => {
      detalharAgendamento();
      listarUsuarios();
    });

    return {
      columns,
      columns2,
      agendamentoUuid,
      detalharAgendamento,
      dados,
      voltar,
      listaUsuariosAgendamento,
      rightDrawerOpen,
      dadosCriarCapacitacao,
      receberDadosCriarCapacitacao,
      adicionarPessoas,
      dadosAgendamento,
      selected,
      listarUsuarios,
      listaUsuarios,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      resetVariaveis,
      verificarUsuario,
      buscarParticipante,
      criarCapacitacaoPorAgendamento,
      finalizarCapacitacao,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
.container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  top: 106px;
  height: calc(100% - 10px);
  position: fixed;
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
tbody tr td {
  white-space: pre-wrap;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 18px !important;
  }
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }

  .input {
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
